import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import Brand from "../../../src/components/Brand";
import {useAppSelector} from "src/store/store";
import ThemeToggle from "../theme-toggle";

const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const isClickable = useAppSelector((state) => state.license.isClickable);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen((prev) => !prev);
    };

    const baseLinkClasses = "block py-2 pr-4 pl-3 border-b border-gray-100 lg:border-0 lg:p-0 transition-colors duration-200";
    const colorLinkClasses = "text-gray-700 hover:bg-gray-50 lg:hover:bg-transparent lg:hover:text-primary-700 dark:text-gray-300 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700";
    const linkClasses = `${baseLinkClasses} ${colorLinkClasses} ${isClickable ? 'cursor-not-allowed pointer-events-none opacity-60' : ''}`;

    return (
        <header className="sticky top-0 z-50 w-full shadow-sm bg-white dark:bg-gray-900 transition-colors duration-300">
            <nav className="border-b border-gray-200 dark:border-gray-800 px-4 lg:px-6 py-2.5">
                {/* MASAÜSTÜ İÇİN 3 BÖLMELİ FLEX YAPISI */}
                <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">

                    {/* 1. SOL BÖLGE: Logo */}
                    <div className="flex items-center lg:w-1/3 justify-start">
                        <Link to="/"
                              className={`flex items-center ${isClickable ? 'cursor-not-allowed pointer-events-none' : ''}`}>
                            <Brand/>
                        </Link>
                    </div>

                    {/* 2. ORTA BÖLGE: Menü Linkleri (Sadece Desktop'ta görünür) */}
                    <div className="hidden lg:flex lg:w-1/3 justify-center">
                        <ul className="flex space-x-8 font-medium">
                            <li><Link to="/" className={linkClasses}>Ana Sayfa</Link></li>
                            <li><a href="https://destek.oska.com.tr/" target="_blank" rel="noreferrer"
                                   className={linkClasses}>Oska Destek</a></li>
                            <li><a href="https://help.oska.com.tr/" target="_blank" rel="noreferrer"
                                   className={linkClasses}>Yardım</a></li>
                        </ul>
                    </div>

                    {/* 3. SAĞ BÖLGE: Butonlar ve Tema (Sadece Desktop'ta görünür) */}
                    <div className="hidden lg:flex lg:w-1/3 justify-end items-center gap-3">
                        <button
                            disabled={isClickable}
                            onClick={() => navigate('/update')}
                            className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            Güncelleme
                        </button>
                        <button
                            disabled={isClickable}
                            onClick={() => navigate('/activate')}
                            className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            Lisanslama
                        </button>
                        <ThemeToggle/>
                    </div>

                    {/* MOBİL KONTROLLER: Hamburger Menü ve Tema */}
                    <div className="flex items-center lg:hidden gap-2">
                        <ThemeToggle/>
                        <button
                            onClick={toggleMobileMenu}
                            type="button"
                            className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 transition-colors"
                        >
                            <span className="sr-only">Menüyü Aç/Kapat</span>
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd"
                                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                      clipRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                {/* MOBİL AÇILIR MENÜ BÖLGESİ */}
                <div
                    className={`${isMobileMenuOpen ? 'block' : 'hidden'} lg:hidden w-full mt-4 border-t border-gray-100 dark:border-gray-700 pt-4`}>
                    <ul className="flex flex-col space-y-4 font-medium">
                        <li><Link to="/" className={linkClasses}>Ana Sayfa</Link></li>
                        <li><a href="https://destek.oska.com.tr/" target="_blank" rel="noreferrer"
                               className={linkClasses}>Oska Destek</a></li>
                        <li><a href="https://help.oska.com.tr/" target="_blank" rel="noreferrer"
                               className={linkClasses}>Yardım</a></li>
                    </ul>
                    <div className="flex flex-col gap-3 mt-4">
                        <button
                            disabled={isClickable}
                            onClick={() => navigate('/update')}
                            className="w-full text-white bg-primary-600 hover:bg-primary-700 font-medium rounded-lg text-sm px-4 py-2.5 dark:bg-primary-600 transition-colors"
                        >
                            Güncelleme
                        </button>
                        <button
                            disabled={isClickable}
                            onClick={() => navigate('/activate')}
                            className="w-full text-white bg-primary-600 hover:bg-primary-700 font-medium rounded-lg text-sm px-4 py-2.5 dark:bg-primary-600 transition-colors"
                        >
                            Lisanslama
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Navbar;